<template>
    <div class="l-login">
        <div class="l-form">
            <div class="justify-content-center" style="margin-left: 12%;">
                <img src="https://chezagame.com/images/chezagame-logo.png" width="190px" />
            </div>
    
            <div class="row">
                <form @submit.prevent="goToLogin">
                    <div class="col">
                        <h2>Forgot | Chezagame</h2>
                        <div v-show="forgotStatus">
                            <small class="text-red">{{forgotStatusMessage}}</small>
                        </div>
                    </div>
                    <div class="col">
                        <label>Phone number</label>
                        <input type="tel" v-model="msisdn" placeholder="Enter phone number" />
                    </div>
    
                    <div class="col">
                        <button type="submit" class="button primary" id="forgot" @click="goToVerify()">Next</button>
                    </div>
                </form>
                <div class="col">
                    <router-link :to="{name: 'login'}">Back to Login</router-link>
                </div>
    
            </div>
        </div>
    </div>
</template>

<script>
import store from "../store";
import $ from 'jquery'
export default {
    data: function() {
        return {
            msisdn: '',
            forgotStatus: false,
            forgotStatusMessage: '',
            verifyCode: ""
        }
    },
    methods: {
        goToVerify() {
            this.forgotStatus = false;
            this.forgotStatusMessage = "";
            var vm = this;
            $('#forgot').html('<i class="fa fa-spinner fa-spin"></i> Loading...');
            $.post({
                url: store.state.rootUrl + 'portal/v1/reset',
                type: "POST",
                headers: {
                    "X-App-Key": "09lib74145Qb3HO6eQTIfsbylRkyuZFT",
                    "X-Authorization-Key": "ADMIN_APP",
                    "X-Requested-With": "XMLHttpRequest",
                    "Content-Type": "application/json"
                },
                data: JSON.stringify({
                    user_name: vm.msisdn,
                    country_code: "254",
                }),
                success: function(response, status, jQxhr) {
                    // console.log(JSON.stringify(response.data.data));
                    if (response.data.code == 200) {
                        vm.$cookies.set("user_name", vm.msisdn);
                        vm.$router.push({
                            name: 'verify'
                        });
                    } else {
                        $('#forgot').text('Next')
                        vm.forgotStatus = true;
                        vm.forgotStatusMessage = response.data.message
                    }
                },
                error: function(jQxhr, status, error) {
                    var statustext = jQxhr.responseJSON.statusDescription;
                    vm.forgotStatus = true;
                    $('#forgot').text('Next')
                    if (!statustext) {
                        vm.forgotStatusMessage = "An error occurred. Try again later.";
                    } else {
                        vm.forgotStatusMessage = statustext;;
                    }
                }
            });

        }
    }
}
</script>
